export type ValidationResult = {
    valid: boolean
    message?: string
}

export const validateUsername = (username: string): ValidationResult => {
    if (username.toLowerCase().includes('.eth')) {
        return {
            valid: false,
            message: 'Username cannot contain .eth. Add an ENS display name instead.',
        }
    }

    const regex = /^[a-zA-Z0-9_-]{1,16}$/
    if (!regex.test(username)) {
        return {
            valid: false,
            message:
                'Username must be 1-16 characters long and contain only letters, numbers, underscores, or hyphens.',
        }
    }

    return { valid: true }
}

export const validateDisplayName = (displayName: string) => {
    const trimmedDisplayName = displayName.trim()

    if (trimmedDisplayName.toLowerCase().includes('.eth')) {
        return {
            valid: false,
            message: 'Display name cannot contain .eth. Add an ENS display name instead.',
        }
    }
    if (trimmedDisplayName.length > 32) {
        return {
            valid: false,
            message: 'Your display name must be between 1 and 32 characters',
        }
    }
    return { valid: true }
}
